import { Route, Routes, useLocation } from "react-router-dom";
import { routes } from "./routes/routes";
import { checkCredential, constant } from "../utils/utils";
import NotFound from "../containers/NotFound";
import ErrorMessage from "../containers/ErrorMessage";
import useSelector from "../store/selector";
import { useEffect, useState } from "react";

const MainRouter = () => {
  const location = useLocation();
  const { getRecoilVal } = useSelector();
  const userData = getRecoilVal(constant.atomsName.USER_DETAIL);
  const [userStatus, setUserStatus] = useState(false);

  useEffect(() => {
    // console.log("useEffect called");
    async function checkStatus() {
      try {
        let result = await checkCredential(userData);
        setUserStatus(result);
      } catch (error) {
        // console.log("error----", error);
      }
    }
    checkStatus();
  }, [location?.pathname]);

  return (
    <>
      {/* <Routes>
        {routes.map((route) => (
          <Route
            exact={route.exact}
            path={route.path}
            element={<route.element {...route.props} />}
            // render={() => {
            //   return <route.element {...route.props} />;
            // }}
            key={route.key}
          />
        ))}
      </Routes> */}

      <Routes>
        {/* {checkCredential(userData) && */}
        {userStatus &&
          routes.map((route) => (
            <>
              <Route
                exact={route.exact}
                path={route.path}
                element={<route.element {...route.props} />}
                key={route.key}
              />
            </>
          ))}
        <Route
          path="/error"
          exact={false}
          element={<ErrorMessage />}
          key={100}
        />
        <Route
          path="*"
          element={
            <NotFound
              credentialErr={
                // !checkCredential(userData) &&
                !userStatus &&
                routes.filter((data) => data.path === location.pathname)
                  ?.length > 0 &&
                true
              }
            />
          }
          key={101}
        />
      </Routes>
    </>
  );
};

export default MainRouter;
